/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/* 
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */
if(!window.GS) GS={};
if(!window.GS.Toolbar) GS.Toolbar={};
if(!window.GS.Toolbar.Frame) GS.Toolbar.Frame={};
(function(){
    var f;
    f = new Class({
        Extends: GS.Toolbar.Tools,
        class_name:'GS.Toolbar.Frame.ObjectEffects',
        options:{
            'wrapper': null,
            'class':'submenu full',
            'lexico':{'w':'Width','o':'Opacity'},
            'toolbar':null
        },
        controlled:null,
        initialize:function(conf){
           this.options.lexico=Locale.get('Toolbar.bordereffects');
           this.parent(conf);
        }
    });
    /**
     *  Link with toolbar wrapper.....
     **/

    f.prototype.menuTMPL=function(){
        var out='   <li class="slider effect-hue" data-type="object-effect-hue" data-uitype="slider" title="{tooltip_h}"><label class="min">{hMin}</label><label>{h}</label><label class="max">{hMax}</label></li>';
        out+='      <li class="separator-h"></li>';
        out+='      <li class="slider effect-saturation" data-type="object-effect-saturation" data-uitype="slider" title="{tooltip_s}"><label class="min">{sMin}</label><label>{s}</label><label class="max">{sMax}</label></li>';
        out+='      <li class="separator-h"></li>';
        out+='      <li class="slider effect-brightness" data-type="object-effect-lightness" data-uitype="slider" title="{tooltip_l}"><label class="min">{lMin}</label><label>{l}</label><label class="max">{lMax}</label></li>';
        out+='      <li class="separator-h"></li>';
       
        out+='      <li class="text-color" data-type="object-effect-color"  id="toolbar-objecteffect-color" data-uitype="colorpicker" title="{tooltip_c}"><div class="color-placeholder"></div></li>';
        out+='      <li class="on-off" data-uitype="checkbox" data-type="object-effect-colorize" title="{tooltip_enable_colorize}"><label>{enable_colorize}</label></li>';
        out+='      <li class="separator-h"></li>';
        out+='      <li class="reset" data-uitype="full-btn" data-type="reset-object-effects" title="{tooltip_reset}">{reset}</li>';
        //out+='<li class="send-to-back" data-type="send-to-back"><label>{b}</label></li>';
        //out=out.substitute(Locale.get('Toolbar.stroke'));
        return out;
    };
    
    this.ObjectEffects = f;
    
}.call(this.GS.Toolbar.Frame));
